import React, { Component, useState } from 'react'
import { MDBContainer, MDBRow, MDBCol, MDBJumbotron,  MDBAlert,  MDBTable, MDBTableBody, MDBTableHead, MDBBtn, MDBIcon, MDBBadge, MDBInput, MDBView, MDBDataTable, MDBTabPane, MDBTabContent,MDBNav, MDBNavItem, MDBNavLink, MDBFormInline} from "mdbreact";
import Axios from 'axios'
import { Layout, Menu, Breadcrumb, Icon, Select, Input, Button ,Card, Divider, Steps  } from 'antd';
import { StarOutlined, StarFilled, StarTwoTone, CaretDownOutlined, UserOutlined, RightCircleOutlined, SearchOutlined } from '@ant-design/icons';

import Highlighter from 'react-highlight-words';
//import Modalteachingschedule from './Modalteachingschedule';
//import Modalcolor from './Modalcolor';
//import { Table,   Space } from 'antd';
import { useReactToPrint } from 'react-to-print';
import jsPDF from 'jspdf';  
import html2canvas from 'html2canvas';  
import QueueAnim from 'rc-queue-anim';

import Table from '@material-ui/core/Table';  
import { CSVLink, CSVDownload } from "react-csv";
import ReactExport from "react-export-excel";
import { Bar } from "react-chartjs-2";
import { Chart } from "react-google-charts";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';

ChartJS.register(ArcElement, Tooltip, Legend);

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

//import Button from '@material-ui/core/Button';  
    
////import React, { useRef } from "react"
// const MyComponent1 = () => {
//   const [text, setText] = useState("hello");
//   const [text2, setText2] = useState("hello2");

//   return (
//     <>
//       <p>Text : {text}</p>
//       <input onChange={(e) => setText(e.target.value)} value={text} />
//       <p>Texts : {text2}</p>
//       <input onChange={(e) => setText2(e.target.value)} value={text2} />
//     </>
//   );
// };


export default class Showadmin extends Component {
    
    constructor(props) {
        super(props);
        this.state = {

          thschedule:[],
          modal: false,
          term:'',
          type:'1',
          idemp:'',
          empcouncilcheck:[],
          empcouncilcheck2:[],
          showteachingschedule:[],
          dd3:'',
          teacher:'',
          major:'',
          search: '',
          student: [],
          buttnoshow: false,
          activeItem: "1",
          pagination: {
            current: 1,
            pageSize: 20,
          },

          amountCurricul:'',
          Approve_Cu:'',
          Approve_Cutrue:'',
          Approve_Dean:'',
          Approve_grade:'',
          numstudent:'',//จำนวนนักศึกาาทั้งหมด
          numregister:[],//จำนวนผู้ลงเรียนแต่ละหลักสูตร

          facultydata01:[],
          facultydata02:[],
          facultydata03:[],
          facultydata04:[],
          facultydata05:[],
          facultydata06:[],
          facultydata08:[],

          team08:'',


        };


        this.onChangemajor = this.onChangemajor.bind(this);
        this.onFocus = this.onFocus.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.onSearch = this.onSearch.bind(this);

        this.getthschedule = this.getthschedule.bind(this);
        this.updateSearchDepartment = this.updateSearchDepartment.bind(this);
        this.getreportnumstudent = this.getreportnumstudent.bind(this);
        this.time = this.time.bind(this);
        this.sentpdf = this.sentpdf.bind(this);
        this.resetdata = this.resetdata.bind(this);
        this.getreportnumregister = this.getreportnumregister.bind(this);
        this.refreshPage = this.refreshPage.bind(this);
        this.toggle = this.toggle.bind(this);
        this.handleChangeteam08 = this.handleChangeteam08.bind(this);
        this.searchteam08 = this.searchteam08.bind(this);

        
      }


      updateSearchDepartment(value) {
        // console.log(event.target.value)
        // const term = event.target.value;
        const term = value;
        this.setState({ term });
 
           setTimeout(() => {
             this.getthschedule()
           }, 500);
      }

      getthschedule() {
        setTimeout(() => {
           //ภายใน
            Axios.get('https://mua.kpru.ac.th/FrontEnd_Tabian/load/getthschedule/'+this.state.term)
           .then(res => {
             console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ thschedule: res.data})
           }) 
         }, 0);
      }


      sentpdf() {
        setTimeout(() => {
          window.open('https://e-student.kpru.ac.th/vaccinekpru/vaccinepdf/report/tess.php?stu='+this.state.major+'', '_blank');
           // window.location.href ='http://localhost/tesspdf/TCPDF-main/tess.php?term='+this.state.term+'&idemp='+this.state.idemp 
         }, 0);
      }


      onChangemajor= e =>{
       console.log(e.target.value);
         // const idemp = value;
          this.setState({ major:e.target.value });

        //   setTimeout(() => {
        //      Axios.get('https://git.kpru.ac.th/FrontEnd_Tabian/load/getthcouncilcheck/1/'+this.state.term+'/'+this.state.idemp)
        //     .then(res => {
        //             this.setState({ empcouncilcheck: res.data})
        //     }) 
        //   }, 0);

        //   setTimeout(() => {
        //      Axios.get('https://git.kpru.ac.th/FrontEnd_Tabian/load/getthcouncilcheck/2/'+this.state.term+'/'+this.state.idemp)
        //     .then(res => {
        //             this.setState({ empcouncilcheck2: res.data})
        //     }) 
        //   }, 0);
        //   setTimeout(() => {
        //     this.getteachingschedule()
        //   }, 500);
     }


     //ดึงจำนวนนักศึกษาทั้งหมด
     getreportnumstudent() {
      setTimeout(() => {
         //ภายใน
          Axios.get('https://mua.kpru.ac.th/FrontEnd_creditbank/administator/reportnumstudent')
         .then(res => {
          // console.log(res);
         //  this.setState({ bankname: res.data, loading: false })
           this.setState({ numstudent: res.data[0].numstudent})
         }) 
       }, 0);
    }


      //ดึงจำนวนที่ลงทะเบียนในหลักสูตร
      getreportnumregister() {
        setTimeout(() => {
           //ภายใน
            Axios.get('https://mua.kpru.ac.th/FrontEnd_creditbank/administator/reportnumregister')
           .then(res => {
         //    console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             const faculty01 = res.data.filter( ({ Curriculumopen_faculty }) => Curriculumopen_faculty === '01' );
             const faculty02 = res.data.filter( ({ Curriculumopen_faculty }) => Curriculumopen_faculty === '02' );
             const faculty03 = res.data.filter( ({ Curriculumopen_faculty }) => Curriculumopen_faculty === '03' );
             const faculty04 = res.data.filter( ({ Curriculumopen_faculty }) => Curriculumopen_faculty === '04' );
             const faculty05 = res.data.filter( ({ Curriculumopen_faculty }) => Curriculumopen_faculty === '05' );
             const faculty06 = res.data.filter( ({ Curriculumopen_faculty }) => Curriculumopen_faculty === '06' );
             const faculty08 = res.data.filter( ({ Curriculumopen_faculty }) => Curriculumopen_faculty === '08' );


             this.setState({ numregister: res.data})
             this.setState({ facultydata01: faculty01})
             this.setState({ facultydata02: faculty02})
             this.setState({ facultydata03: faculty03})
             this.setState({ facultydata04: faculty04})
             this.setState({ facultydata05: faculty05})
             this.setState({ facultydata06: faculty06})
             this.setState({ facultydata08: faculty08})
           }) 
         }, 0);
      }


          resetdata= e =>{
          //  console.log(e.target.value);
              // const idemp = value;
              this.setState({ major:'' });
          }

          toggle = tab => e => {
            if (this.state.activeItem !== tab) {
              this.setState({
                activeItem: tab
              });
            }
          };


          onBlur() {
            console.log('blur');
          }
          
          onFocus() {
            console.log('focus');
          }
          
          onSearch(val) {
            console.log('search:', val);
          }

          time() {
            const d = new Date();
            d.setMinutes(17);
            document.getElementById("demo").innerHTML = d;
          }

          refreshPage() {
            window.location.reload(false);
          }

          handleChangeteam08(event) {  
              this.setState({team08: event.target.value}); 
          }

          searchteam08() {

            const faculty08 = this.state.facultydata08.filter( ({ Curriculumopen_TEAM }) => Curriculumopen_TEAM === this.state.team08 );
            this.setState({ facultydata08: faculty08})
           
          }
          


          componentDidMount(){
           
              if (localStorage.getItem('name') == null) {   
                  window.location.href = 'https://e-student.kpru.ac.th/creditbank'
                } else {
            
                }

                    Axios.get(`https://mua.kpru.ac.th/FrontEnd_creditbank/administator/reportnum`,
                      //  Axios.get(`https://mis.kpru.ac.th/api/EmployeeInOrg/000`,
                      {headers: {
                        // Authorization: 'Bearer ' + localStorage.getItem('myData')
                      }
                      })
                      //  axios.defaults.headers.common['Authorization'] = `Bearer` + localStorage.getItem('myData') 
                      .then(res => {
                         // console.log(res.data[0].id)
                        // console.log(res.data)
                        //  const reportnum = res.data;
                          this.setState({ 
                            amountCurricul :  res.data[0].amountCurricul,
                            Approve_Cu :  res.data[0].Approve_Cu,
                            Approve_Cutrue :  res.data[0].Approve_Cutrue,
                            Approve_Dean :  res.data[0].Approve_Dean,
                            Approve_grade :  res.data[0].Approve_grade,
                            data : [15, 19, 13, 5, 2, 3]
                          });
                      })
                        this.getreportnumstudent();
                        this.getreportnumregister();
          }


          getColumnSearchProps = dataIndex => ({
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters , filters}) => (
              <div style={{ padding: 8 }}>
                <Input
                  ref={node => {
                    this.searchInput = node;
                  }}
                  placeholder={`ค้นหา`}
                  value={selectedKeys[0]}
                  onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                  onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
                  style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                <Button
                  type="primary"
                  onClick={() => this.handleSearch(selectedKeys, confirm)}
                  icon=""
                  size="small"
                  style={{ width: 90, marginRight: 8 }}
                >
                  ค้นหา
                </Button>
                <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                  ยกเลิก
                </Button>
              </div>
            ),
            filterIcon: filtered => (
              <SearchOutlined />
        
            ),
        
            onFilter: (value, record) =>
              record[dataIndex]
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
              if (visible) {
                setTimeout(() => this.searchInput.select());
              }
            },
        
            
            render: text => (
              <Highlighter
                highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                searchWords={[this.state.searchText]}
                autoEscape
                textToHighlight={text.toString()}
              />
            ),
          });
        
          handleSearch = (selectedKeys, confirm) => {
            confirm();
            this.setState({ searchText: selectedKeys[0] });
          };
        
          handleReset = clearFilters => {
            clearFilters();
            this.setState({ searchText: '' });
          };
                
          clearFilters = () => {
            this.setState({ filteredInfo: null });
          };
        
        
          clearAll = () => {
            this.setState({
              filteredInfo: null,
              sortedInfo: null,
            });
          };



          printDocument() {  
            const input = document.getElementById('pdfdiv');  
            html2canvas(input)  
              .then((canvas) => {  
                var imgWidth = 200;  
                var pageHeight = 290;  
                var imgHeight = canvas.height * imgWidth / canvas.width;  
                var heightLeft = imgHeight;  
                const imgData = canvas.toDataURL('image/png');  
                const pdf = new jsPDF('l', 'mm', 'a4')  
                var position = 10;  
                var heightLeft = imgHeight;  
                pdf.addImage(imgData, 'JPEG', 5, position, imgWidth, imgHeight);  
                pdf.save("download.pdf");  
              });  
          } 
 


    render() {
      let { sortedInfo, filteredInfo } = this.state;
      sortedInfo = sortedInfo || {};
      filteredInfo = filteredInfo || {};
      const {  pagination } = this.state;
     
      const { Step } = Steps;
      const  data = [
        
          { firstname: "Ahmed", lastname: "Tomi", email: "ah@smthing.co.com" },
          { firstname: "Raed", lastname: "Labes", email: "rl@smthing.co.com" },
          { firstname: "Yezzi", lastname: "Min l3b", email: "ymin@cocococo.com" }
        ];

        // console.log(_.filter(this.state.student, { message2: 'เข็มที่ 1' }));
        //  const ppp = this.state.student.find( ({ message2 }) => message2 === 'เข็มที่ 1' );
        //  console.log(ppp)
      const { Option } = Select;
        //  const studentsa =  this.state.student.map(showteachingschedule => { 
        //   [  { firstname: showteachingschedule.citizen_id, lastname: showteachingschedule.citizen_id, email: showteachingschedule.citizen_id } ] 
        //   }  )   
      const Approve_Cu = Number (this.state.Approve_Cu);

    const data1 = [
      ["Task", "Hours per Day"],
      ["อยู่ระหว่างดำเนินการ", Number (this.state.Approve_Cu)],
      ["อนุมัติแล้ว",  Number (this.state.Approve_Cutrue)],
     ];
  
    const options = {
      chart: {
       // title: "Company Performance",
        // subtitle: "Sales, Expenses, and Profit: 2014-2017",
      },
    };







    const datast = {
      columns: [
        {
          label: '#',
          field: 'list',
          sort: 'list',
          width: 150
        },
        {
          label: 'รหัสวิชา',
          field: 'Course_ID',
          sort: 'Course_ID',
          width: 150
        },
        {
          label: 'ชื่อ',
          field: 'Curriculumopen_Full_Name_TH',
          sort: 'Curriculumopen_Full_Name_TH',
          width: 150
        },
        {
          label: 'ผู้สอน',
          field: 'Teacher_NAME',
          sort: 'Teacher_NAME',
          width: 150
        },
        {
          label: 'ภาคเรียน',
          field: 'Curriculumopen_TEAM',
          sort: 'Curriculumopen_TEAM',
          width: 270
        },
        {
          label: 'จำนวน',
          field: 'NUMST',
          sort: 'NUMST',
          width: 200
        },
        {
          label: 'เกรด P',
          field: 'GRADEP',
          sort: 'GRADEP',
          width: 100
        },
        {
          label: 'เกรด PD',
          field: 'GRADEPD',
          sort: 'GRADEPD',
          width: 150
        },
        {
          label: 'เกรด F',
          field: 'GRADEF',
          sort: 'GRADEF',
          width: 150
        }
      ],


      rows: [...this.state.numregister.map((data, i) => (
    
        {
   

           list: <>{i+1}</>,
           Course_ID: <>{data.Course_ID}</>,
           Curriculumopen_Full_Name_TH: <>{data.Curriculumopen_Full_Name_TH}</>,
          //  <br/>
          //               <Steps current={2}>
          //                   <Step title="กดส่ง"  />
          //                   <Step title="หลักสูตร" subTitle="" description={'อนุมัติ'} />
          //                   <Step title="คณบดี" description={'อนุมัติ'} />
          //                   <Step title="เสร็จสิ้น" description={'อนุมัติ'}/>
                          
          //               </Steps>
           
           Teacher_NAME: <>{data.Teacher_PNAME}{data.Teacher_NAME} {data.Teacher_LASTNAME}</>,
           Curriculumopen_TEAM: <>{data.Curriculumopen_TEAM}</>,
           NUMST: <>{data.NUMST}</>,
           GRADEP: <>{data.P}</>,
           GRADEPD: <>{data.PD}</>,
           GRADEF: <>{data.F}</>,       
           random: <h5 searchvalue={data.Curriculumopen_TEAM} >tourist <span className="badge badge-danger">narrow</span></h5>,
        }
       ))]
  
      };
          const persons = <MDBDataTable
        // searching ={true}
          searchLabel="ค้นหา ชื่อหลักสูตร"
          striped
          bordered
          small 
          entries={20}
        // entriesOptions={["10", "20"]}
          order={["age", "desc"]}
          data={datast}
          entriesLabel="จำนวนที่แสดง "
          infoLabel= {["แสดง", "ถึง", "จากทั้งหมด", "รายการ"]}
          paginationLabel={["ย้อนกลับ", "ถัดไป"]}
          responsive 
          sortRows={['random']}
        //  theadColor={"#ff4444"}
          />



      // เทคโนโลยีอุตสาหกรรม
          const datast05 = {
            columns: [
              {
                label: '#',
                field: 'list',
                sort: 'list',
                width: 150
              },
              {
                label: 'ชื่อ',
                field: 'Curriculumopen_Full_Name_TH',
                sort: 'Curriculumopen_Full_Name_TH',
                width: 150
              },
              {
                label: 'ผู้สอน',
                field: 'Teacher_NAME',
                sort: 'Teacher_NAME',
                width: 150
              },
              {
                label: 'ภาคเรียน',
                field: 'Curriculumopen_TEAM',
                sort: 'Curriculumopen_TEAM',
                width: 270
              },
              {
                label: 'จำนวน',
                field: 'NUMST',
                sort: 'NUMST',
                width: 200
              },
              {
                label: 'เกรด P',
                field: 'GRADEP',
                sort: 'GRADEP',
                width: 100
              },
              {
                label: 'เกรด PD',
                field: 'GRADEPD',
                sort: 'GRADEPD',
                width: 150
              },
              {
                label: 'เกรด F',
                field: 'GRADEF',
                sort: 'GRADEF',
                width: 150
              }
            ],
      
            rows: [...this.state.facultydata05.map((data, i) => (
              {
                 list: <>{i+1}</>,
                 Curriculumopen_Full_Name_TH: <>{data.Curriculumopen_Full_Name_TH}</>,
                 Teacher_NAME: <>{data.Teacher_PNAME}{data.Teacher_NAME} {data.Teacher_LASTNAME}</>,
                 Curriculumopen_TEAM: <>{data.Curriculumopen_TEAM}</>,
                 NUMST: <>{data.NUMST}</>,
                 GRADEP: <>{data.P}</>,
                 GRADEPD: <>{data.PD}</>,
                 GRADEF: <>{data.F}</>,
                
                random: <h5 searchvalue={data.Curriculumopen_TEAM} >tourist <span className="badge badge-danger">narrow</span></h5>,
              }
             ))]
            };

                const persons05 = <MDBDataTable
              // searching ={true}
                searchLabel="ค้นหา ชื่อหลักสูตร"
                striped
                bordered
                small 
                entries={20}
              // entriesOptions={["10", "20"]}
                order={["age", "desc"]}
                data={datast05}
                entriesLabel="จำนวนที่แสดง "
                infoLabel= {["แสดง", "ถึง", "จากทั้งหมด", "รายการ"]}
                paginationLabel={["ย้อนกลับ", "ถัดไป"]}
                responsive 
                sortRows={['random']}
                />

                

            //พยาบาล
                const datast08 = {
                  columns: [
                    {
                      label: '#',
                      field: 'list',
                      sort: 'list',
                      width: 150
                    },
                    {
                      label: 'ชื่อ',
                      field: 'Curriculumopen_Full_Name_TH',
                      sort: 'Curriculumopen_Full_Name_TH',
                      width: 150
                    },
                    {
                      label: 'ผู้สอน',
                      field: 'Teacher_NAME',
                      sort: 'Teacher_NAME',
                      width: 150
                    },
                    {
                      label: 'ภาคเรียน',
                      field: 'Curriculumopen_TEAM',
                      sort: 'Curriculumopen_TEAM',
                      width: 270
                    },
                    {
                      label: 'จำนวน',
                      field: 'NUMST',
                      sort: 'NUMST',
                      width: 200
                    },
                    {
                      label: 'เกรด P',
                      field: 'GRADEP',
                      sort: 'GRADEP',
                      width: 100
                    },
                    {
                      label: 'เกรด PD',
                      field: 'GRADEPD',
                      sort: 'GRADEPD',
                      width: 150
                    },
                    {
                      label: 'เกรด F',
                      field: 'GRADEF',
                      sort: 'GRADEF',
                      width: 150
                    }
                  ],
            
                  rows: [...this.state.facultydata08.map((data, i) => (
                    {
                       list: <>{i+1}</>,
                       Curriculumopen_Full_Name_TH: <>{data.Curriculumopen_Full_Name_TH}</>,
                       Teacher_NAME: <>{data.Teacher_PNAME}{data.Teacher_NAME} {data.Teacher_LASTNAME}</>,
                       Curriculumopen_TEAM: <>{data.Curriculumopen_TEAM}</>,
                       NUMST: <>{data.NUMST}</>,
                       GRADEP: <>{data.P}</>,
                       GRADEPD: <>{data.PD}</>,
                       GRADEF: <>{data.F}</>,
                      
                      random: <h5 searchvalue={data.Curriculumopen_TEAM} >tourist <span className="badge badge-danger">narrow</span></h5>,
                
                    }
                   ))]
                  };
            
                      const persons08 = <MDBDataTable
                    // searching ={true}
                      searchLabel="ค้นหา ชื่อหลักสูตร"
                      striped
                      bordered
                      small 
                      entries={20}
                    // entriesOptions={["10", "20"]}
                      order={["age", "desc"]}
                      data={datast08}
                      entriesLabel="จำนวนที่แสดง "
                      infoLabel= {["แสดง", "ถึง", "จากทั้งหมด", "รายการ"]}
                      paginationLabel={["ย้อนกลับ", "ถัดไป"]}
                      responsive 
                      sortRows={['random']}
                      />

                  

                //วิทยาศาสตร์และเทคโนโลยี
                const datast01 = {
                  columns: [
                    {
                      label: '#',
                      field: 'list',
                      sort: 'list',
                      width: 150
                    },
                    {
                      label: 'ชื่อ',
                      field: 'Curriculumopen_Full_Name_TH',
                      sort: 'Curriculumopen_Full_Name_TH',
                      width: 150
                    },
                    {
                      label: 'ผู้สอน',
                      field: 'Teacher_NAME',
                      sort: 'Teacher_NAME',
                      width: 150
                    },
                    {
                      label: 'ภาคเรียน',
                      field: 'Curriculumopen_TEAM',
                      sort: 'Curriculumopen_TEAM',
                      width: 270
                    },
                    {
                      label: 'จำนวน',
                      field: 'NUMST',
                      sort: 'NUMST',
                      width: 200
                    },
                    {
                      label: 'เกรด P',
                      field: 'GRADEP',
                      sort: 'GRADEP',
                      width: 100
                    },
                    {
                      label: 'เกรด PD',
                      field: 'GRADEPD',
                      sort: 'GRADEPD',
                      width: 150
                    },
                    {
                      label: 'เกรด F',
                      field: 'GRADEF',
                      sort: 'GRADEF',
                      width: 150
                    }
                  ],

                  rows: [...this.state.facultydata01.map((data, i) => (
                    {
                      list: <>{i+1}</>,
                      Curriculumopen_Full_Name_TH: <>{data.Curriculumopen_Full_Name_TH}</>,
                      Teacher_NAME: <>{data.Teacher_PNAME}{data.Teacher_NAME} {data.Teacher_LASTNAME}</>,
                      Curriculumopen_TEAM: <>{data.Curriculumopen_TEAM}</>,
                      NUMST: <>{data.NUMST}</>,
                      GRADEP: <>{data.P}</>,
                      GRADEPD: <>{data.PD}</>,
                      GRADEF: <>{data.F}</>,
                      random: <h5 searchvalue={data.Curriculumopen_TEAM} >tourist <span className="badge badge-danger">narrow</span></h5>,
                    }
                  ))]
                  };

                    const persons01 = <MDBDataTable
                      // searching ={true}
                      searchLabel="ค้นหา ชื่อหลักสูตร"
                      striped
                      bordered
                      small 
                      entries={20}
                      // entriesOptions={["10", "20"]}
                      order={["age", "desc"]}
                      data={datast01}
                      entriesLabel="จำนวนที่แสดง "
                      infoLabel= {["แสดง", "ถึง", "จากทั้งหมด", "รายการ"]}
                      paginationLabel={["ย้อนกลับ", "ถัดไป"]}
                      responsive 
                      sortRows={['random']}
                    />



                //ครุศาสตร์
                const datast02 = {
                  columns: [
                    {
                      label: '#',
                      field: 'list',
                      sort: 'list',
                      width: 150
                    },
                    {
                      label: 'ชื่อ',
                      field: 'Curriculumopen_Full_Name_TH',
                      sort: 'Curriculumopen_Full_Name_TH',
                      width: 150
                    },
                    {
                      label: 'ผู้สอน',
                      field: 'Teacher_NAME',
                      sort: 'Teacher_NAME',
                      width: 150
                    },
                    {
                      label: 'ภาคเรียน',
                      field: 'Curriculumopen_TEAM',
                      sort: 'Curriculumopen_TEAM',
                      width: 270
                    },
                    {
                      label: 'จำนวน',
                      field: 'NUMST',
                      sort: 'NUMST',
                      width: 200
                    },
                    {
                      label: 'เกรด P',
                      field: 'GRADEP',
                      sort: 'GRADEP',
                      width: 100
                    },
                    {
                      label: 'เกรด PD',
                      field: 'GRADEPD',
                      sort: 'GRADEPD',
                      width: 150
                    },
                    {
                      label: 'เกรด F',
                      field: 'GRADEF',
                      sort: 'GRADEF',
                      width: 150
                    }
                  ],

                  rows: [...this.state.facultydata02.map((data, i) => (
                    {
                      list: <>{i+1}</>,
                      Curriculumopen_Full_Name_TH: <>{data.Curriculumopen_Full_Name_TH}</>,
                      Teacher_NAME: <>{data.Teacher_PNAME}{data.Teacher_NAME} {data.Teacher_LASTNAME}</>,
                      Curriculumopen_TEAM: <>{data.Curriculumopen_TEAM}</>,
                      NUMST: <>{data.NUMST}</>,
                      GRADEP: <>{data.P}</>,
                      GRADEPD: <>{data.PD}</>,
                      GRADEF: <>{data.F}</>,
                      random: <h5 searchvalue={data.Curriculumopen_TEAM} >tourist <span className="badge badge-danger">narrow</span></h5>,
                    }
                  ))]
                  };

                    const persons02 = <MDBDataTable
                      // searching ={true}
                      searchLabel="ค้นหา ชื่อหลักสูตร"
                      striped
                      bordered
                      small 
                      entries={20}
                      // entriesOptions={["10", "20"]}
                      order={["age", "desc"]}
                      data={datast02}
                      entriesLabel="จำนวนที่แสดง "
                      infoLabel= {["แสดง", "ถึง", "จากทั้งหมด", "รายการ"]}
                      paginationLabel={["ย้อนกลับ", "ถัดไป"]}
                      responsive 
                      sortRows={['random']}
                    />



                //มนุษยศาสตร์และสังคมศาสตร์
                const datast03 = {
                  columns: [
                    {
                      label: '#',
                      field: 'list',
                      sort: 'list',
                      width: 150
                    },
                    {
                      label: 'ชื่อ',
                      field: 'Curriculumopen_Full_Name_TH',
                      sort: 'Curriculumopen_Full_Name_TH',
                      width: 150
                    },
                    {
                      label: 'ผู้สอน',
                      field: 'Teacher_NAME',
                      sort: 'Teacher_NAME',
                      width: 150
                    },
                    {
                      label: 'ภาคเรียน',
                      field: 'Curriculumopen_TEAM',
                      sort: 'Curriculumopen_TEAM',
                      width: 270
                    },
                    {
                      label: 'จำนวน',
                      field: 'NUMST',
                      sort: 'NUMST',
                      width: 200
                    },
                    {
                      label: 'เกรด P',
                      field: 'GRADEP',
                      sort: 'GRADEP',
                      width: 100
                    },
                    {
                      label: 'เกรด PD',
                      field: 'GRADEPD',
                      sort: 'GRADEPD',
                      width: 150
                    },
                    {
                      label: 'เกรด F',
                      field: 'GRADEF',
                      sort: 'GRADEF',
                      width: 150
                    }
                  ],

                  rows: [...this.state.facultydata03.map((data, i) => (
                    {
                      list: <>{i+1}</>,
                      Curriculumopen_Full_Name_TH: <>{data.Curriculumopen_Full_Name_TH}</>,
                      Teacher_NAME: <>{data.Teacher_PNAME}{data.Teacher_NAME} {data.Teacher_LASTNAME}</>,
                      Curriculumopen_TEAM: <>{data.Curriculumopen_TEAM}</>,
                      NUMST: <>{data.NUMST}</>,
                      GRADEP: <>{data.P}</>,
                      GRADEPD: <>{data.PD}</>,
                      GRADEF: <>{data.F}</>,
                      random: <h5 searchvalue={data.Curriculumopen_TEAM} >tourist <span className="badge badge-danger">narrow</span></h5>,
                    }
                  ))]
                  };
                    const persons03 = <MDBDataTable
                      // searching ={true}
                      searchLabel="ค้นหา ชื่อหลักสูตร"
                      striped
                      bordered
                      small 
                      entries={20}
                      // entriesOptions={["10", "20"]}
                      order={["age", "desc"]}
                      data={datast03}
                      entriesLabel="จำนวนที่แสดง "
                      infoLabel= {["แสดง", "ถึง", "จากทั้งหมด", "รายการ"]}
                      paginationLabel={["ย้อนกลับ", "ถัดไป"]}
                      responsive 
                      sortRows={['random']}
                    />


                  //วิทยาการจัดการ
                  const datast04 = {
                        columns: [
                          {
                            label: '#',
                            field: 'list',
                            sort: 'list',
                            width: 150
                          },
                          {
                            label: 'ชื่อ',
                            field: 'Curriculumopen_Full_Name_TH',
                            sort: 'Curriculumopen_Full_Name_TH',
                            width: 150
                          },
                          {
                            label: 'ผู้สอน',
                            field: 'Teacher_NAME',
                            sort: 'Teacher_NAME',
                            width: 150
                          },
                          {
                            label: 'ภาคเรียน',
                            field: 'Curriculumopen_TEAM',
                            sort: 'Curriculumopen_TEAM',
                            width: 270
                          },
                          {
                            label: 'จำนวน',
                            field: 'NUMST',
                            sort: 'NUMST',
                            width: 200
                          },
                          {
                            label: 'เกรด P',
                            field: 'GRADEP',
                            sort: 'GRADEP',
                            width: 100
                          },
                          {
                            label: 'เกรด PD',
                            field: 'GRADEPD',
                            sort: 'GRADEPD',
                            width: 150
                          },
                          {
                            label: 'เกรด F',
                            field: 'GRADEF',
                            sort: 'GRADEF',
                            width: 150
                          }
                        ],
      
                        rows: [...this.state.facultydata04.map((data, i) => (
                          {
                            list: <>{i+1}</>,
                            Curriculumopen_Full_Name_TH: <>{data.Curriculumopen_Full_Name_TH}</>,
                            Teacher_NAME: <>{data.Teacher_PNAME}{data.Teacher_NAME} {data.Teacher_LASTNAME}</>,
                            Curriculumopen_TEAM: <>{data.Curriculumopen_TEAM}</>,
                            NUMST: <>{data.NUMST}</>,
                            GRADEP: <>{data.P}</>,
                            GRADEPD: <>{data.PD}</>,
                            GRADEF: <>{data.F}</>,
                            random: <h5 searchvalue={data.Curriculumopen_TEAM} >tourist <span className="badge badge-danger">narrow</span></h5>,
                          }
                        ))]
                  };
                         const persons04 = <MDBDataTable
                            // searching ={true}
                            searchLabel="ค้นหา ชื่อหลักสูตร"
                            striped
                            bordered
                            small 
                            entries={20}
                            // entriesOptions={["10", "20"]}
                            order={["age", "desc"]}
                            data={datast04}
                            entriesLabel="จำนวนที่แสดง "
                            infoLabel= {["แสดง", "ถึง", "จากทั้งหมด", "รายการ"]}
                            paginationLabel={["ย้อนกลับ", "ถัดไป"]}
                            responsive 
                            sortRows={['random']}
                          />


                  //แม่สอด
                  const datast06 = {
                    columns: [
                      {
                        label: '#',
                        field: 'list',
                        sort: 'list',
                        width: 150
                      },
                      {
                        label: 'ชื่อ',
                        field: 'Curriculumopen_Full_Name_TH',
                        sort: 'Curriculumopen_Full_Name_TH',
                        width: 150
                      },
                      {
                        label: 'ภาคเรียน',
                        field: 'Curriculumopen_TEAM',
                        sort: 'Curriculumopen_TEAM',
                        width: 270
                      },
                      {
                        label: 'จำนวน',
                        field: 'NUMST',
                        sort: 'NUMST',
                        width: 200
                      },
                      {
                        label: 'เกรด P',
                        field: 'GRADEP',
                        sort: 'GRADEP',
                        width: 100
                      },
                      {
                        label: 'เกรด PD',
                        field: 'GRADEPD',
                        sort: 'GRADEPD',
                        width: 150
                      },
                      {
                        label: 'เกรด F',
                        field: 'GRADEF',
                        sort: 'GRADEF',
                        width: 150
                      }
                    ],
  
                    rows: [...this.state.facultydata06.map((data, i) => (
                      {
                        list: <>{i+1}</>,
                        Curriculumopen_Full_Name_TH: <>{data.Curriculumopen_Full_Name_TH}</>,
                        Curriculumopen_TEAM: <>{data.Curriculumopen_TEAM}</>,
                        NUMST: <>{data.NUMST}</>,
                        GRADEP: <>{data.P}</>,
                        GRADEPD: <>{data.PD}</>,
                        GRADEF: <>{data.F}</>,
                        random: <h5 searchvalue={data.Curriculumopen_TEAM} >tourist <span className="badge badge-danger">narrow</span></h5>,
                      }
                    ))]
              };
                     const persons06 = <MDBDataTable
                        // searching ={true}
                        searchLabel="ค้นหา ชื่อหลักสูตร"
                        striped
                        bordered
                        small 
                        entries={20}
                        // entriesOptions={["10", "20"]}
                        order={["age", "desc"]}
                        data={datast06}
                        entriesLabel="จำนวนที่แสดง "
                        infoLabel= {["แสดง", "ถึง", "จากทั้งหมด", "รายการ"]}
                        paginationLabel={["ย้อนกลับ", "ถัดไป"]}
                        responsive 
                        sortRows={['random']}
                      />


                      const data99 = {
                        labels: ['อยู่ระหว่างยื่นและพิจารณาหลักสูตร', 'หลักสูตรพิจารณาอนุมัติแล้ว'],
                        datasets: [
                          {
                            label: '# of Votes',
                            data: [Number (this.state.Approve_Cu), Number (this.state.Approve_Cutrue)],
                            backgroundColor: [
                              'rgba(255, 99, 132, 0.2)',
                              'rgba(54, 162, 235, 0.2)',
                              // 'rgba(255, 206, 86, 0.2)',
                              // 'rgba(75, 192, 192, 0.2)',
                              // 'rgba(153, 102, 255, 0.2)',
                              // 'rgba(255, 159, 64, 0.2)',
                            ],
                            borderColor: [
                              'rgba(255, 99, 132, 1)',
                              'rgba(54, 162, 235, 1)',
                              // 'rgba(255, 206, 86, 1)',
                              // 'rgba(75, 192, 192, 1)',
                              // 'rgba(153, 102, 255, 1)',
                              // 'rgba(255, 159, 64, 1)',
                            ],
                            borderWidth: 1,
                          },
                        ],
                      };


        return (
            <MDBContainer fluid>
       <Card type="inner" style={{ marginTop: 16 }}  title={<h4><MDBIcon icon="list-alt" /> สำหรับผู้ดูแลระบบ</h4> } extra={<a href="#"><p>คุณ{localStorage.getItem('name')}</p></a>} >
    
      </Card>
        
                <Card title="">
                <QueueAnim>
                  <div key="1">
                        <Card type="inner" title="จำนวนหลักสูตร" extra={<a href="#">More</a>}>
                          <MDBRow center>
                            <h3 className="display-5 deep-purple-text text-center" > จำนวนหลักสูตรทั้งหมด</h3> <br/>
                          </MDBRow>
                          <div className="text-center">
                            <h4>จำนวน {this.state.amountCurricul} หลักสูตร</h4> <br/>
                          </div>
                           
                          <MDBRow >
                            <MDBCol size="8" center>  
                              {/* <MDBAlert color="primary" >
                              <h4>อยู่ระหว่างพิจารณาหลักสูตร : {this.state.Approve_Cu}</h4>
                              <h4>พิจารณาอนุมัติแล้ว : {this.state.Approve_Dean}</h4>
                              <h4>สอนเสร็จสิ้น : {this.state.Approve_grade}</h4>
                              </MDBAlert> */}
                              <MDBTable>
                                  <MDBTableHead color="grey darken-1" textWhite>
                                    <tr>
                                      <th><b>ลำดับ</b></th>
                                      <th><b>รายการ</b></th>
                                      <th><b>จำนวน</b></th>
                                    </tr>
                                  </MDBTableHead>
                                  <MDBTableBody>
                                   
                                    <tr>
                                      <td>1</td>
                                      <td>- อยู่ระหว่างยื่นและพิจารณาหลักสูตร</td>
                                      <td>{this.state.Approve_Cu}</td>
                                    </tr>
                                    <tr>
                                      <td></td>
                                      <td>- หลักสูตรพิจารณาอนุมัติแล้ว</td>
                                      <td>{this.state.Approve_Cutrue}</td>
                                    </tr>
                                    <tr>
                                      <td>2</td>
                                      <td>สอนเสร็จสิ้น</td>
                                      <td>{this.state.Approve_grade}</td>
                                    </tr>
                                  </MDBTableBody>
                              </MDBTable>
                          </MDBCol>
                          <MDBCol size="4" center>
                              <MDBAlert color="light" >
                                กราฟแสดงจำนวนหลักสูตร<br/>
                                    
                                      <Doughnut data={data99}  />
                              </MDBAlert>
                          </MDBCol>
                            {/* <MDBCol size="2" center>
                           
                            </MDBCol> */}
                          </MDBRow>

                        </Card>
                        </div>
            
                        {/* ----- */}
                       
                        <Card
                            style={{ marginTop: 16 }}
                            type="inner"
                            title="จำนวนผู้เรียน"
                            extra={<a href="#">More</a>}
                          >
                          <MDBRow center>
                            <h3 className="display-5 deep-purple-text text-center">จำนวนผู้เรียนทั้งหมด</h3> 
                          </MDBRow>
                          <div className="text-center">
                            <h4> {this.state.numstudent} คน</h4> <br/>
                          </div>
                        </Card>
                      
                        {/* ----- */}      
                        <Card
                            style={{ marginTop: 16 }}
                            type="inner"
                            title="จำนวนผู้เรียนแต่ละหลักสูตร"
                            extra={<a href="#">More</a>}
                          >
                          <MDBRow center>
                            <h3 className="display-5 deep-purple-text text-center">จำนวนผู้เรียนแต่ละหลักสูตร</h3> 
                          </MDBRow>
                          
                          {persons} 

                          <ExcelFile filename="รายงาน" element={<Button size="small">  &nbsp; <MDBIcon icon="file-excel" />&nbsp; EXPORT EXCEl </Button>}>
                           
                            <ExcelSheet data={this.state.numregister} name="รายงานข้อมูลสรุป">
                                <ExcelColumn label="ชื่อหลักสูตร" style={{ rgb: "009900" }} value="Curriculumopen_Full_Name_TH" />
                                <ExcelColumn label="ชื่อ" value ="Teacher_NAME"  />
                                <ExcelColumn label="นามสกุ" value ="Teacher_NAME"  />
                                <ExcelColumn label="ภาคเรียน" value="Curriculumopen_TEAM" />
                                <ExcelColumn label="จำนวน" value="NUMST" />
                                <ExcelColumn label="เกรด P" value="P" />
                                {/* <ExcelColumn label="Transfer Amount" value={(col)=>(col.Salary+col.payslip_revenue)-col.payslip_expenditure} />  */}
                                {/* <ExcelColumn label="Transfer Amount" value={(col) => Number(col.Salary) + Number(col.payslip_revenue)} /> */}
                                <ExcelColumn label="เกรด PD" value="PD" />
                                <ExcelColumn label="เกรด F" value="F" />
                            </ExcelSheet>
                        </ExcelFile>
                        </Card>

                         {/* ----- */}      
                         <Card
                            style={{ marginTop: 16 }}
                            type="inner"
                            title="จำนวนผู้เรียนแต่ละหลักสูตร แยกคณะ"
                            extra={<a href="#">More</a>}
                          >
                              <MDBRow center>
                                <h3 className="display-5 deep-purple-text text-center">จำนวนผู้เรียนแต่ละหลักสูตร แยกคณะ</h3> 
                                
                              </MDBRow>
                              <MDBNav className="nav-tabs mt-5">
                                      <MDBNavItem>
                                        <MDBNavLink link to="#" active={this.state.activeItem === "1"} onClick={this.toggle("1")} role="tab" >
                                          คณะวิทยาศาสตร์และเทคโนโลยี
                                        </MDBNavLink>
                                      </MDBNavItem>
                                      <MDBNavItem>
                                        <MDBNavLink link to="#" active={this.state.activeItem === "2"} onClick={this.toggle("2")} role="tab" >
                                          คณะครุศาสตร์
                                        </MDBNavLink>
                                      </MDBNavItem>
                                      <MDBNavItem>
                                        <MDBNavLink link to="#" active={this.state.activeItem === "3"} onClick={this.toggle("3")} role="tab" >
                                          คณะมนุษยศาสตร์และสังคมศาสตร์
                                        </MDBNavLink>
                                      </MDBNavItem>
                                      <MDBNavItem>
                                        <MDBNavLink link to="#" active={this.state.activeItem === "4"} onClick={this.toggle("4")} role="tab" >
                                          คณะวิทยาการจัดการ
                                        </MDBNavLink>
                                      </MDBNavItem>
                                      <MDBNavItem>
                                        <MDBNavLink link to="#" active={this.state.activeItem === "5"} onClick={this.toggle("5")} role="tab" >
                                         คณะเทคโนโลยีอุตสาหกรรม
                                        </MDBNavLink>
                                      </MDBNavItem> 
                                      <MDBNavItem>
                                        <MDBNavLink link to="#" active={this.state.activeItem === "6"} onClick={this.toggle("6")} role="tab" >
                                         มหาวิทยาลัยราชภัฏกำแพงเพชร แม่สอด
                                        </MDBNavLink>
                                      </MDBNavItem>
                                      <MDBNavItem>
                                        <MDBNavLink link to="#" active={this.state.activeItem === "8"} onClick={this.toggle("8")} role="tab" >
                                          คณะพยาบาลศาสตร์
                                        </MDBNavLink>
                                      </MDBNavItem>
                                    </MDBNav>


                                    <MDBTabContent activeItem={this.state.activeItem} >
                                      <MDBTabPane tabId="1" role="tabpanel">
                                        <p className="mt-2 text-center">
                                        คณะวิทยาศาสตร์และเทคโนโลยี
                                        </p>
                                        {persons01}
                                      </MDBTabPane>
                                      <MDBTabPane tabId="2" role="tabpanel">
                                        <p className="mt-2 text-center">
                                        คณะครุศาสตร์
                                        </p>
                                        {persons02}
                                      </MDBTabPane>
                                      <MDBTabPane tabId="3" role="tabpanel">
                                        <p className="mt-2 text-center">
                                        คณะมนุษยศาสตร์และสังคมศาสตร์
                                        </p>
                                        {persons03}
                                      </MDBTabPane>
                                      <MDBTabPane tabId="4" role="tabpanel">
                                        <p className="mt-2 text-center">
                                        คณะวิทยาการจัดการ
                                        </p>
                                        {persons04}
                                      </MDBTabPane>
                                      <MDBTabPane tabId="5" role="tabpanel">
                                        <p className="mt-2 text-center">
                                        คณะเทคโนโลยีอุตสาหกรรม
                                        </p>
                                        {persons05}
                                      </MDBTabPane>
                                      <MDBTabPane tabId="6" role="tabpanel">
                                        <p className="mt-2 text-center" >
                                        มหาวิทยาลัยราชภัฏกำแพงเพชร แม่สอด
                                        </p>
                                        {persons06}
                                      </MDBTabPane>
                                      <MDBTabPane tabId="8" role="tabpanel">
                                        <p className="mt-2 text-center">
                                         คณะพยาบาลศาสตร์
                                        </p>
                                            
                                            {/* <MDBRow>
                                              <MDBCol>
                                                <div className="form-group">
                                                      <label htmlFor="example2">ค้นหาภาคเรียน เช่น 1/2565</label>
                                                      <input type="text" id="example2" className="form-control form-control-md" placeholder="ระบุ ภาคการเรียน" value={this.state.team08} onChange={this.handleChangeteam08} /><MDBBtn color="primary">Primary</MDBBtn>
                                                </div>
                                              </MDBCol>
                                              <MDBCol></MDBCol>
                                            </MDBRow> */}
                                            <MDBCol md="12"> 
                                            <label htmlFor="example2">ค้นหาภาคเรียน เช่น 1/2565</label>
                                                <MDBFormInline className="md-form mr-auto mt-1 mb-4">
                                                  {/* <input className="form-control mr-sm-2" type="text" placeholder="Search" aria-label="Search" />
                                                  <MDBBtn gradient="aqua" rounded size="sm" type="submit" className="mr-auto">
                                                    Search
                                                  </MDBBtn>
                                                  <input className="form-control mr-sm-2" type="text" placeholder="Search" aria-label="Search" />
                                                  <MDBBtn outline color="warning" rounded size="sm" type="submit" className="mr-auto">
                                                    Search
                                                  </MDBBtn> */}
                                                
                                                  <input className="form-control mr-sm-2" type="text" placeholder="Search" aria-label="Search" value={this.state.team08} onChange={this.handleChangeteam08} />
                                                  <MDBBtn color="unique" rounded size="sm" onClick={this.searchteam08} className="mr-auto">
                                                    ค้นหา
                                                  </MDBBtn>
                                                </MDBFormInline>
                                            </MDBCol>

                                        {persons08}
                                      </MDBTabPane>
                                    </MDBTabContent>

                                          <ExcelFile filename="รายงานแยกคณะ" element={<Button size="small">  &nbsp; <MDBIcon icon="file-excel" />&nbsp; EXPORT EXCEl </Button>}>
                                          <ExcelSheet data={this.state.facultydata01} name="คณะวิทยาศาสตร์และเทคโนโลยี">
                                                <ExcelColumn label="ชื่อ" style={{ rgb: "009900" }} value="Curriculumopen_Full_Name_TH" />
                                                <ExcelColumn label="ภาคเรียน" value="Curriculumopen_TEAM" />
                                                <ExcelColumn label="จำนวน" value="NUMST" />
                                                <ExcelColumn label="เกรด P" value="P" />
                                                <ExcelColumn label="เกรด PD" value="PD" />
                                                <ExcelColumn label="เกรด F" value="F" />
                                            </ExcelSheet>
                                            <ExcelSheet data={this.state.facultydata01} name="คณะครุศาสตร์">
                                                <ExcelColumn label="ชื่อ" style={{ rgb: "009900" }} value="Curriculumopen_Full_Name_TH" />
                                                <ExcelColumn label="ภาคเรียน" value="Curriculumopen_TEAM" />
                                                <ExcelColumn label="จำนวน" value="NUMST" />
                                                <ExcelColumn label="เกรด P" value="P" />
                                                <ExcelColumn label="เกรด PD" value="PD" />
                                                <ExcelColumn label="เกรด F" value="F" />
                                            </ExcelSheet>
                                            <ExcelSheet data={this.state.facultydata03} name="คณะมนุษยศาสตร์และสังคมศาสตร์">
                                                <ExcelColumn label="ชื่อ" style={{ rgb: "009900" }} value="Curriculumopen_Full_Name_TH" />
                                                <ExcelColumn label="ภาคเรียน" value="Curriculumopen_TEAM" />
                                                <ExcelColumn label="จำนวน" value="NUMST" />
                                                <ExcelColumn label="เกรด P" value="P" />
                                                <ExcelColumn label="เกรด PD" value="PD" />
                                                <ExcelColumn label="เกรด F" value="F" />
                                            </ExcelSheet>
                                            <ExcelSheet data={this.state.facultydata04} name="คณะวิทยาการจัดการ">
                                                <ExcelColumn label="ชื่อ" style={{ rgb: "009900" }} value="Curriculumopen_Full_Name_TH" />
                                                <ExcelColumn label="ภาคเรียน" value="Curriculumopen_TEAM" />
                                                <ExcelColumn label="จำนวน" value="NUMST" />
                                                <ExcelColumn label="เกรด P" value="P" />
                                                <ExcelColumn label="เกรด PD" value="PD" />
                                                <ExcelColumn label="เกรด F" value="F" />
                                            </ExcelSheet>
                                            <ExcelSheet data={this.state.facultydata05} name="คณะเทคโนโลยีอุตสาหกรรม">
                                                <ExcelColumn label="ชื่อ" style={{ rgb: "009900" }} value="Curriculumopen_Full_Name_TH" />
                                                <ExcelColumn label="ภาคเรียน" value="Curriculumopen_TEAM" />
                                                <ExcelColumn label="จำนวน" value="NUMST" />
                                                <ExcelColumn label="เกรด P" value="P" />
                                                <ExcelColumn label="เกรด PD" value="PD" />
                                                <ExcelColumn label="เกรด F" value="F" />
                                            </ExcelSheet>
                                            <ExcelSheet data={this.state.facultydata06} name="มรภ.กพ แม่สอด">
                                                <ExcelColumn label="ชื่อ" style={{ rgb: "009900" }} value="Curriculumopen_Full_Name_TH" />
                                                <ExcelColumn label="ภาคเรียน" value="Curriculumopen_TEAM" />
                                                <ExcelColumn label="จำนวน" value="NUMST" />
                                                <ExcelColumn label="เกรด P" value="P" />
                                                <ExcelColumn label="เกรด PD" value="PD" />
                                                <ExcelColumn label="เกรด F" value="F" />
                                            </ExcelSheet>
                                            <ExcelSheet data={this.state.facultydata08} name="คณะพยาบาล">
                                                <ExcelColumn label="ชื่อ" style={{ rgb: "009900" }} value="Curriculumopen_Full_Name_TH" />
                                                <ExcelColumn label="ภาคเรียน" value="Curriculumopen_TEAM" />
                                                <ExcelColumn label="จำนวน" value="NUMST" />
                                                <ExcelColumn label="เกรด P" value="P" />
                                                <ExcelColumn label="เกรด PD" value="PD" />
                                                <ExcelColumn label="เกรด F" value="F" />
                                            </ExcelSheet>
                                          </ExcelFile>


                          </Card>
                          </QueueAnim>

              </Card>


            
            </MDBContainer>
        )
    }
}
